import { render, staticRenderFns } from "./EmailNotificationTemplatesModal.vue?vue&type=template&id=8ae60f12"
import script from "./EmailNotificationTemplatesModal.vue?vue&type=script&lang=js"
export * from "./EmailNotificationTemplatesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports